import { useMemo } from 'react';
import type { PlacerEntityModel } from '@placer-ui/types';
import { Market } from 'core/entities';
import { useReportPlaces } from 'extensions/widget/hooks/use-poi-hooks';
import { useSelector } from 'react-redux';
import { selectExtendedWorkforceMarketCategoriesIds } from 'store/selectors/app-selectors';

export const useExtendedWorkforceEntities = (): PlacerEntityModel<Market>[] => {
    const reportPlaces = useReportPlaces();
    const extendedWorkforceCategoryIds = useSelector(selectExtendedWorkforceMarketCategoriesIds);

    return useMemo(() => {
        const entities = reportPlaces.all;
        return entities.filter((entity: PlacerEntityModel<Market>) => {
            const subCategoryId = entity.originalEntity.category_info?.sub_category_id;
            return subCategoryId && extendedWorkforceCategoryIds.includes(Number(subCategoryId));
        });
    }, [reportPlaces, extendedWorkforceCategoryIds]);
};
